import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  title: string;
  body: string;
  timestamp: string;
}

interface NotificationState {
  list: Notification[];
  count: number;
}

const initialState: NotificationState = {
  list: [],
  count: 0,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.list.unshift(action.payload);
      state.count += 1;
    },
    clearNotifications: state => {
      state.list = [];
      state.count = 0;
    },
  },
});

export const { addNotification, clearNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;
